var isTouchDevice = function () {
    return (Boolean(typeof window !== 'undefined' &&
        ('ontouchstart' in window ||
            // @ts-ignore
            (window.DocumentTouch && typeof document !== 'undefined' && document instanceof window.DocumentTouch))) || !!(typeof navigator !== 'undefined' && (navigator.maxTouchPoints || navigator.msMaxTouchPoints)));
};
export default isTouchDevice;
